<template lang="pug">
v-tab-item
    v-card(:loading="loading")
        v-card-title Create Artists
        v-card-subtitle Create Artists manually
        v-card-text
            v-form(
                ref="form"
                v-model="valid"
                lazy-validation
                :disabled="loading"
            )
                v-file-input(
                    v-model="form.profile_picture"
                    :rules="rules"
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera"
                    label="Profile Photo"
                    dense
                    outlined
                )
                v-text-field(
                    v-model="form.fname"
                    :rules="nameRules"
                    label="Firstname"
                    prepend-icon="mdi-form-textbox"
                    required
                    dense
                    outlined
                )
                v-text-field(
                    v-model="form.lname"
                    :rules="nameRules"
                    label="Lastname"
                    prepend-icon="mdi-form-textbox"
                    required
                    dense
                    outlined
                )
                v-text-field(
                    v-model="form.url"
                    :rules="nameRules"
                    label="Vainity URL"
                    prepend-icon="mdi-at"
                    required
                    dense
                    outlined
                )
                v-text-field(
                    v-model="form.email"
                    name="new-artist-email"
                    :rules="emailRules"
                    label="Email"
                    prepend-icon="mdi-email"
                    required
                    dense
                    outlined
                    autocomplete="new-artist-email"
                )
                v-text-field(
                    v-model="form.password"
                    name="new-artist-password"
                    :rules="nameRules"
                    type="password"
                    label="Password"
                    prepend-icon="mdi-form-textbox-password"
                    required
                    dense
                    outlined
                    autocomplete="new-artist-password"
                )
        v-divider
        v-card-actions
            v-spacer
            v-btn.mr-4(@click="submitForm" text color="primary") Add artist
            
    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close

</template>

<script>
import { mapActions } from 'vuex';
import Config from '../../../../configuration';

export default {
    data() {
        return {
            loading: false,
            error: {
                show: false,
                message: ''
            },
            valid: false,
            form: {
                profile_picture: null,
                fname: null,
                lname: null,
                url: null,
                email: null,
                password: null
            },
            rules: [
                value => !value || value.size < 25000000 || 'Avatar size should be less than 25 MB!',
            ],
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length <= 10) || 'Name must be less than 10 characters',
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ]
        };
    },
    methods: {
        async submitForm() {
            if(this.$refs.form.validate()) {
                this.loading = true;
                try {
                    if(!this.form.profile_picture) {
                        throw new Error('Please select profile picture!');
                    }
                    const urlExists = await this.findUser({
                        query: { url: this.form.url }
                    });
                    if(urlExists.total !== 0) {
                        throw new Error('Vanity URL are not available!');
                    }
                    const emailExists = await this.findUser({
                        query: { email: this.form.email }
                    });
                    if(emailExists.total !== 0) {
                        throw new Error('Email Address already registered!');
                    }
                    const profilePictureRaw = await this.toBase64(this.form.profile_picture);
                    const profileS3File = await fetch(`${Config.host}/api/upload`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': window.localStorage.getItem('feathers-jwt')
                        },
                        body: JSON.stringify({
                            uri: profilePictureRaw
                        })
                    }).then(data => data.json());
                    const result = await this.createUserArtist({
                        profile_picture: `[s3]:${profileS3File.id}`,
                        fname: this.form.fname,
                        lname: this.form.lname,
                        password: this.form.password,
                        is_artist: 1,
                        url: this.form.url
                    });
                    const roles = await this.findRoles({
                        query: { name: 'artist' }
                    }).then(d => d.data[0]);
                    await this.createRole({
                        user_id: result.id,
                        role_id: roles.id
                    });
                    // this.$refs.form.reset();
                } catch(err) {
                    this.error.message = err.message;
                    this.error.show = true;
                } finally {
                    this.loading = false;
                }
            }
        },
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        ...mapActions('users', { findUser: 'find', createUserArtist: 'create' }),
        ...mapActions('bh-user-roles', { createRole: 'create' }),
        ...mapActions('bh-roles', { findRoles: 'find' }),
    }
}
</script>